var _style, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}")), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 146.446,
    x2: 853.553,
    y1: 853.553,
    y2: 146.446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd521"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    style: {
      stopColor: "#ffd020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    style: {
      stopColor: "#fec01e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#fca71b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    style: {
      stopColor: "#fa8316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    style: {
      stopColor: "#f85510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "#f51e09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f30005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#f20007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    style: {
      stopColor: "#e1003b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    style: {
      stopColor: "#d30067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#c70088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    style: {
      stopColor: "#bf00a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#bb00af"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b900b4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500 1000C223.9 1000 0 776.1 0 500S223.9 0 500 0s500 223.9 500 500-223.9 500-500 500z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500 220.2c91.1 0 101.9.3 137.9 2 33.3 1.5 51.4 7.1 63.4 11.8 15.9 6.2 27.3 13.6 39.2 25.5 11.9 11.9 19.3 23.3 25.5 39.2 4.7 12 10.2 30.1 11.8 63.4 1.6 36 2 46.8 2 137.9s-.3 101.9-2 137.9c-1.5 33.3-7.1 51.4-11.8 63.4-6.2 15.9-13.6 27.3-25.5 39.2-11.9 11.9-23.3 19.3-39.2 25.5-12 4.7-30.1 10.2-63.4 11.8-36 1.6-46.8 2-137.9 2s-101.9-.3-137.9-2c-33.3-1.5-51.4-7.1-63.4-11.8-15.9-6.2-27.3-13.6-39.2-25.5-11.9-11.9-19.3-23.3-25.5-39.2-4.7-12-10.2-30.1-11.8-63.4-1.6-36-2-46.8-2-137.9s.3-101.9 2-137.9c1.5-33.3 7.1-51.4 11.8-63.4 6.2-15.9 13.6-27.3 25.5-39.2 11.9-11.9 23.3-19.3 39.2-25.5 12-4.7 30.1-10.2 63.4-11.8 36-1.7 46.8-2 137.9-2m0-61.5c-92.7 0-104.3.4-140.7 2.1-36.3 1.7-61.1 7.4-82.9 15.9C254 185.3 234.9 197 216 216c-19 19-30.6 38-39.4 60.5-8.4 21.7-14.2 46.5-15.9 82.9-1.7 36.4-2.1 48-2.1 140.7 0 92.7.4 104.3 2.1 140.7 1.7 36.3 7.4 61.1 15.9 82.9C185.3 746 197 765.1 216 784c19 19 38 30.6 60.5 39.4 21.7 8.4 46.5 14.2 82.9 15.9 36.4 1.7 48 2.1 140.7 2.1s104.3-.4 140.7-2.1c36.3-1.7 61.1-7.4 82.9-15.9C746 814.7 765.1 803 784 784c19-19 30.6-38 39.4-60.5 8.4-21.7 14.2-46.5 15.9-82.9 1.7-36.4 2.1-48 2.1-140.7s-.4-104.3-2.1-140.7c-1.7-36.3-7.4-61.1-15.9-82.9C814.7 254 803 234.9 784 216c-19-19-38-30.6-60.5-39.4-21.7-8.4-46.5-14.2-82.9-15.9-36.3-1.6-47.9-2-140.6-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500 324.7c-96.8 0-175.3 78.5-175.3 175.3S403.2 675.3 500 675.3 675.3 596.8 675.3 500 596.8 324.7 500 324.7zm0 289.1c-62.8 0-113.8-50.9-113.8-113.8s51-113.8 113.8-113.8S613.8 437.1 613.8 500s-51 113.8-113.8 113.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 682.2,
    cy: 317.8,
    r: 41
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b6f215f2.svg";
export { ForwardRef as ReactComponent };